<app-select
    label="Product"
    [options]="options"
    [control]="control"
    [color]="color"
    tooltip="Select a product"
    [tabIndex]="tabIndex"></app-select>
